/*
 * Footer corner backdrop.
 *
 * The footer has rounded top corners (50px, section-footer.css). Whatever sits behind them is the
 * page background, which shows up as a white wedge under the last section on every page. This
 * copies the bottom 50px of the last section's background (solid colour or gradient) onto a strip
 * behind the footer's corners (see section-footer.css), so the section appears to run under the
 * footer. If the last section has no full-width background, the strip stays off and nothing changes.
 */
(function () {
  'use strict';

  var STRIP = 50; // keep in sync with the footer's border-radius in section-footer.css
  var observer = null;
  var observed = null;

  function hasBackground(cs) {
    var transparent = cs.backgroundColor === 'rgba(0, 0, 0, 0)' || cs.backgroundColor === 'transparent';
    return !transparent || cs.backgroundImage !== 'none';
  }

  // The element that paints the page's bottom edge: walk down the last visible child at each
  // level, then back up to the first ancestor with a background.
  function findBottomElement() {
    var main = document.getElementById('MainContent');
    if (!main) return null;
    var el = main;
    while (el.children.length) {
      var next = null;
      for (var i = el.children.length - 1; i >= 0; i--) {
        var k = el.children[i];
        if (/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(k.tagName)) continue;
        var pos = window.getComputedStyle(k).position;
        if (pos === 'fixed' || pos === 'absolute') continue;
        if (k.offsetHeight > 0) {
          next = k;
          break;
        }
      }
      if (!next) break;
      el = next;
    }
    for (; el; el = el.parentElement) {
      if (hasBackground(window.getComputedStyle(el))) return el;
      if (el === main) break;
    }
    return null;
  }

  function clear(wrap) {
    ['--footer-backdrop-color', '--footer-backdrop-image', '--footer-backdrop-size', '--footer-backdrop-pos'].forEach(function (p) {
      wrap.style.removeProperty(p);
    });
  }

  function update() {
    var wrap = document.querySelector('.shopify-section-group-footer-group');
    if (!wrap) return;
    var src = findBottomElement();
    if (!src) return clear(wrap);

    var rect = src.getBoundingClientRect();
    // Only worth copying when the background actually reaches the viewport edges.
    if (rect.width < document.documentElement.clientWidth - 2) return clear(wrap);

    var cs = window.getComputedStyle(src);
    var image = cs.backgroundImage;
    // Copy gradients only: url() images depend on cover/position rules we can't mirror here.
    var gradientOnly = image !== 'none' && image.indexOf('url(') === -1;
    wrap.style.setProperty('--footer-backdrop-color', cs.backgroundColor);
    if (gradientOnly) {
      wrap.style.setProperty('--footer-backdrop-image', image);
      wrap.style.setProperty('--footer-backdrop-size', Math.round(rect.width) + 'px ' + Math.round(rect.height) + 'px');
      wrap.style.setProperty('--footer-backdrop-pos', '0 ' + (STRIP - Math.round(rect.height)) + 'px');
    } else {
      wrap.style.setProperty('--footer-backdrop-image', 'none');
    }

    if (window.ResizeObserver && observed !== src) {
      if (observer) observer.disconnect();
      observer = new ResizeObserver(update);
      observer.observe(src);
      observed = src;
    }
  }

  function init() {
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', update);
  window.addEventListener('resize', update);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', update);
})();
